import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import { FaCircle, FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { inventoryStatus } from "../../../constants/constant";

const toIDR = (val) =>
  val.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const CardStockDetailBatch = ({
  isWarehouse,
  dataDetail,
  isFetchingDetail,
}) => {
  const stringToColour = (str) => {
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }
    return colour;
  };

  return (
    <div>
      <div className="bg-white rounded-lg p-3">
        <div className="flex w-full">
          <div className="w-full">
            <div className="block overflow-x-auto w-full">
              <table className="w-full overflow-x-auto-md border-collapse">
                <thead className="bg-[#F7F8F9]">
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    No
                  </th>
                  <th className="p-2 text-left whitespace-nowrap w-fit">
                    Tanggal
                  </th>
                  <th className="p-2 text-left whitespace-nowrap w-fit">
                    No Transaksi
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Stok Awal
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Stok Masuk
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Stok Keluar
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Stok Akhir
                  </th>
                  <th className="p-2 text-left w-fit">Supplier</th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    HNA
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Diskon
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    PPN
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Harga Akhir
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    Harga Jual
                  </th>
                  <th className="p-2 text-left whitespace-nowrap w-fit">
                    Aktivitas
                  </th>
                  <th className="p-2 text-center whitespace-nowrap w-fit">
                    User Log
                  </th>
                </thead>
                <tbody>
                  {dataDetail && dataDetail.length > 0 && !isFetchingDetail ? (
                    dataDetail.map((item, i) => (
                      <tr className="text-center border-b" key={i}>
                        <td className="p-3 text-center">{i + 1}</td>
                        <td className="p-3 text-left whitespace-nowrap text-nowrap">
                          {moment(item.created_at).format("DD MMMM YYYY")}
                        </td>
                        <td className="p-3 text-left">{item.relational_id}</td>
                        <td className="p-3 text-center">
                          {item.stock_current}
                        </td>
                        <td className="p-3 text-center">{item.stock_in}</td>
                        <td className="p-3 text-center">{item.stock_out}</td>
                        <td className="p-3 text-center">
                          {item.stock_current + item.stock_in - item.stock_out}
                        </td>
                        <td className="p-3 text-center">
                          {item.supplier_name}
                        </td>
                        <td className="p-3 text-center">
                          {toIDR(item.pharmacy_net_price)}
                        </td>
                        <td className="p-3 text-center">
                          {item.pharmacy_net_price_discount}%
                        </td>
                        <td className="p-3 text-center">
                          {item.pharmacy_net_price_ppn_value}%
                        </td>
                        <td className="p-3 text-center">
                          {toIDR(item.pharmacy_net_price_real)}
                        </td>
                        <td className="p-3 text-center">
                          {toIDR(item.sell_price)}
                        </td>

                        <td
                          className="p-3 text-left"
                          style={{
                            color: `${stringToColour(item.status)}`,
                          }}
                        >
                          <div className="whitespace-nowrap flex items-center gap-2">
                            <FaCircle />
                            <p>{item.status}</p>
                          </div>
                        </td>
                        <td className="p-3 text-center whitespace-nowrap">
                          {item.user_log}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={15} className="p-3 text-center border-b">
                        {isFetchingDetail ? (
                          <CircularProgress size={20} />
                        ) : (
                          <div className="py-5">
                            <p className="text-[18px] font-semibold mb-2">
                              Tidak ada detail data
                            </p>
                            <p className="mb-4">Silahkan coba lagi</p>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardStockDetailBatch;
